import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, IconButton, Popover } from '@mui/material';

import { capitalizeFirstLetter } from '../../../../Utils/helperFns';
import InputCheckbox from '../../../../Components/CheckBox';
import Images from '../../../../Utils/images';
// import { getRoleDetails } from '../rolesManagementAction'

interface PopoverProps {
  children: any;
}

function InfoPopover(Props: PopoverProps) {
  const { children } = Props;
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  return (
    <>
      <IconButton
        aria-owns={open ? 'info-popover' : undefined}
        aria-haspopup="true"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
      >
        <img src={Images.QUESTION} alt="Info" />
      </IconButton>
      <Popover
        id="info-popover"
        sx={{
          pointerEvents: 'none',
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        <Box sx={{ p: 2, maxWidth: '450px' }}>{children}</Box>
      </Popover>
    </>
  );
}

export default function ProductionRoles({
  roles,
  name,
  visibility,
  roleDetails,
  handleChangeCall,
  label,
  handleChangeVisiblity,
}: any) {
  console.log('Roles : >', roleDetails, roles, name);

  // const handleChange = (e: any, type: any, name: string, key: string) => {
  //   // console.log(e, label, name, key)
  //   // let obj = JSON.p
  //   const check = e.target.checked;
  //   if (check) {
  //     if (type === 'otherPermissions') {
  //       // console.log(e, label, type, name, key)
  //       handleChangeCall(true, label, name, key, type);
  //     } else {
  //       handleChangeCall(true, label, name, key);
  //     }
  //     //   roleDetails['productionPermissions'][name][key] = true
  //   } else {
  //     if (type === 'otherPermissions') {
  //       // console.log(e, label, type, name, key)
  //       handleChangeCall(false, label, name, key, type);
  //     } else {
  //       handleChangeCall(false, label, name, key);
  //     }

  //     //   roleDetails['productionPermissions'][name][key] = false
  //   }
  // };

  const handleChange = (e: any, type: any, name: string, key: string) => {
    handleChangeCall(e.target.checked, label, name, key, type);
  };

  const list = () => {
    if (roles?.[name]) {
      return Object.entries(roles?.[name] || {})?.map(
        ([key, value]: any, i: number) => {
          return (
            <li key={i}>
              <InputCheckbox
                label={capitalizeFirstLetter(key)}
                checked={value}
                id=""
                name=""
                disabled
                labelColor="#000000"
                labelSize="medium"
                onChange={(e: any) => handleChange(e, undefined, name, key)}
              />
            </li>
          );
        },
      );
    }
  };

  //   console.log('RRRRRRRRRRRRRr=>>>>>>', roleDetails)

  // console.log('Is frozen:', roleDetails)

  function addSpaceToCamelCase(text: string): string {
    return text.replace(/([a-z])([A-Z])/g, '$1 $2');
  }

  const othersList = () => {
    if (roles?.otherPermissions) {
      return Object.entries(roles?.otherPermissions || {})?.map(
        ([key, value]: any, i: number) => {
          return (
            <ul className="rolesList padding border" key={i}>
              <li className="roleType">
                <p>{addSpaceToCamelCase(capitalizeFirstLetter(key))}</p>
              </li>
              {Object.entries(value)?.map(
                ([keyName, checkValue]: any, index: number) => {
                  return (
                    <li key={`${key}-${keyName}`}>
                      <InputCheckbox
                        label={capitalizeFirstLetter(keyName)}
                        checked={checkValue}
                        id=""
                        name=""
                        labelColor="#000000"
                        disabled
                        labelSize="medium"
                        onChange={(e: any) =>
                          handleChange(e, 'otherPermissions', key, keyName)
                        }
                      />
                    </li>
                  );
                },
              )}
            </ul>
          );
        },
      );
    }
  };

  return (
    <div className="accordian">
      <Accordion elevation={0} defaultExpanded>
        {/* <AccordionSummary
                    
                    aria-controls="panel1-content"
                    id="panel1-header"
                >
                    Accordion 1
                </AccordionSummary> */}
        <AccordionDetails>
          <ul className="rolesList padding border">
            <li className="roleType bold">
              <p>{capitalizeFirstLetter(name)}</p>
            </li>
            {list()}
            {/* 
              <InputCheckbox
                id=""
                name=""
                label="Can Extend"
                labelColor="#000000"
                labelSize="medium"
              />
            </li> */}
          </ul>
        </AccordionDetails>
      </Accordion>
      <Accordion elevation={0} className="with_border">
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2-content"
          id="panel2-header"
        >
          <div className="rolesList">
            <div className="roleType bold">
              <p>Other Permissions</p>
            </div>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          {othersList()}

          {/* <Grid item md={12} xs={12} sx={{ mt: 2 }}>
            <p>
              Receive Chat From Anyone{' '}
              <CustomSwitch
                showLabel
                checked={roleDetails?.chatAccess}
                labelColor="#5089AC"
                labelSize="small"
                label="Restrict Chat Access to Owner, Production Head, and Department Head"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  handleChangeVisiblity(
                    e.target.checked,
                    undefined,
                    'chatAccess'
                  )
                }
              />
            </p>
          </Grid> */}
        </AccordionDetails>
      </Accordion>
      {roleDetails?.staticRole !== 'Day Player' && (
        <Accordion elevation={0}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3-content"
            id="panel3-header"
          >
            <div className="rolesList">
              <div className="roleType bold">
                <p>Permission Visibility</p>
              </div>
            </div>
          </AccordionSummary>
          <AccordionDetails>
            <div>
              <ul className="rolesList">
                <li className="roleType full">
                  <p>
                    Finance Visibility
                    <span>
                      <InfoPopover
                        children={
                          <div className="rolesPopover">
                            <h3>Finance Visibility</h3>
                            <p>
                              All: Can view all financials within a production
                            </p>
                            <p>
                              Department: User Can view financials within a
                              department
                            </p>
                            <p>
                              Own: Can view financials for orders placed by this
                              user
                            </p>
                          </div>
                        }
                      />
                    </span>
                  </p>
                </li>
              </ul>
              <ul className="rolesList">
                {['all', 'department', 'own']?.map((item: any, i: number) => {
                  return (
                    <li className="roleType" key={i}>
                      <InputCheckbox
                        label={capitalizeFirstLetter(item)}
                        id=""
                        name=""
                        checked={
                          // true
                          roles?.permissionVisibility?.financeVisibility?.includes(
                            item,
                          )
                            ? true
                            : false
                        }
                        labelColor="#000000"
                        disabled
                        labelSize="medium"
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                          handleChangeVisiblity(
                            e.target.checked,
                            item,
                            label,
                            'financeVisibility',
                          )
                        }
                      />
                    </li>
                  );
                })}
              </ul>
            </div>

            <div>
              <ul className="rolesList">
                <li className="roleType full">
                  <p>
                    Document Visibility
                    <span>
                      <InfoPopover
                        children={
                          <div className="rolesPopover">
                            <h3>Document Visibility</h3>
                            <p></p>
                            <p>
                              Department: Can view all documents within a
                              department
                            </p>
                            <p>
                              Own: Can view documents uploaded by this user or
                              any document marked as "view all"
                            </p>
                          </div>
                        }
                      />
                    </span>
                  </p>
                </li>
              </ul>
              <ul className="rolesList">
                {['all', 'department', 'own']?.map((item: any, i: number) => {
                  return (
                    <li className="roleType" key={i}>
                      <InputCheckbox
                        label={capitalizeFirstLetter(item)}
                        id=""
                        name=""
                        checked={
                          // true
                          roles?.permissionVisibility?.documentVisibility?.includes(
                            item,
                          )
                            ? true
                            : false
                        }
                        disabled
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                          handleChangeVisiblity(
                            e.target.checked,
                            item,
                            label,
                            'documentVisibility',
                          )
                        }
                        labelColor="#000000"
                        labelSize="medium"
                      />
                    </li>
                  );
                })}

                {/* <li>
                <InputCheckbox
                  id=""
                  name=""
                  label="Can Extend"
                  labelColor="#000000"
                  labelSize="medium"
                />
              </li> */}
              </ul>
            </div>
          </AccordionDetails>
        </Accordion>
      )}
    </div>
  );
}
